import React from 'react';
import { XIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { painPoints } from '../../data/landing';
export function Problem() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-227" data-mp="2roeyzzn0baqv">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-228" data-mp="2rn3tnvdwxuxn">
        <div data-id="element-229" data-mp="2moivs2m4vncd">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-brand md:text-6xl" data-id="element-230" data-mp="2mp20uiqoqh8z">
            ¿Cuántos domingos más vas a vivir <span className="text-danger" data-id="element-231" data-mp="2cre5prp637qa">con esto?</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-charcoal" data-id="element-232" data-mp="2ct8slbk019x0">
            Tienes colon irritable. Amas comer. Pero nadie te dijo que ibas a pasar los domingos
            con miedo a qué cocinar, los almuerzos evitando ciertos alimentos y llegando a la noche
            inflamado sin entender por qué.
          </p>
          <p className="mt-6 text-2xl font-extrabold leading-snug text-charcoal" data-id="element-233" data-mp="1zcms7xt2zhc">
            No es mala suerte. <Highlight data-id="element-234" data-mp="14bbq400xukrn">Es falta de un sistema.</Highlight>
          </p>
        </div>

        <div data-id="element-235" data-mp="19a56q1biurw1">
          <ul className="divide-y divide-danger/15 overflow-hidden rounded-3xl border border-danger/20 bg-danger-soft" data-id="element-236" data-mp="199wvedv1rumy">
            {painPoints.map(p => <li key={p} className="flex items-start gap-4 px-6 py-5" data-id="element-237" data-mp="vc86muxv03cm">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-238" data-mp="10a9qhi3406p5">
                  <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-239" data-mp="1nzks11saa54c" />
                </span>
                <span className="text-base font-medium text-charcoal md:text-lg" data-id="element-240" data-mp="1s2qwq4zqzo8p">{p}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xl font-bold italic text-brand md:text-left" data-id="element-241" data-mp="1j7t1gr94nze7">
            ¿Y si este fuera el último fin de semana que vives así?
          </p>
        </div>
      </div>
    </section>;
}